import React from 'react';
import { AppMenuItem, Card, CloseButton, HR as Hr, Overlay } from './Menu.styles';
import { color } from '@nuvolo/nuux-theme/utils';
import FAIcon from '#/common/components/FAIcon';
import useApplicationPickerItems from '#/app/hooks/useApplicationPickerItems';
import If from '#/common/components/If';
import { useAuth } from 'react-oidc-context';
import { ApplicationPickerItem } from './applicationPickerItems';

interface ApplicationPickerCardProps {
  onClose: () => void;
  opened?: boolean;
  variant?: 'desktop' | 'mobile';
}

const formPostRedirect = (postEndpoint: string, idToken: string) => {
  const form = document.createElement('form');
  form.method = 'POST';
  form.action = postEndpoint;
  form.target = '_blank';
  const tokenInput = document.createElement('input');
  tokenInput.type = 'hidden';
  tokenInput.name = 'id_token';
  tokenInput.value = idToken;
  form.appendChild(tokenInput);
  document.body.appendChild(form);
  form.submit();
  form.remove();
};

const ApplicationPickerCard: React.FC<ApplicationPickerCardProps> = ({
  onClose,
  opened = false,
  variant = 'desktop',
}) => {
  const appItems = useApplicationPickerItems();
  const { user } = useAuth();

  const handlePickerItemClick = (item: Exclude<ApplicationPickerItem, 'separator'>) => {
    onClose();
    if (item.authType === 'FormPostRedirect' && item.postEndpoint && user?.id_token) {
      formPostRedirect(item.postEndpoint, user.id_token);
    } else if (item.url) {
      // TMM app navigates in same tab, all others open in new tab
      if (
        item.id === process.env.REACT_APP_TMM_APP_ID ||
        item.id === '0b12c499-83ad-4ace-a3bb-98209dbd0911'
      ) {
        globalThis.location.href = item.url;
      } else {
        globalThis.open(item.url, '_blank');
      }
    }
  };

  return (
    <If condition={opened}>
      <Overlay onClick={onClose} />
      <Card variant={variant} w={320} type="appPicker">
        {variant === 'mobile' && (
          <CloseButton onClick={() => onClose()}>
            <FAIcon icon="xmark" color={color('secondary', 'dark2')} />
          </CloseButton>
        )}
        {appItems
          .filter((item, i, items) => {
            if (item === 'separator') {
              return items[i + 1] !== 'separator' && i < items.length - 1;
            }
            return true;
          })
          .map((item, index) =>
            item === 'separator' ? (
              <Hr key={`separator-${index}`} />
            ) : (
              <AppMenuItem
                key={`${item.name}-${item.url}`}
                size="md"
                onClick={() => handlePickerItemClick(item)}>
                <FAIcon icon={item.icon} color={color('custom', 'iconGray')} />
                <span className="item-text">{item.name}</span>
              </AppMenuItem>
            ),
          )}
      </Card>
    </If>
  );
};

export default ApplicationPickerCard;
